import useSlingApi from '@sdk/api/useSlingApi';
import useToast from '@sdk/common/toast/useToast';
import { extendBillingInfo } from '@sdk/account/utils';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';

export const useGrant50PercentOffModal = (accept) => {
  const { onBillingInfoUpdated } = useBillingInfo();
  const { showErrorToast } = useToast();
  const api = useSlingApi();

  const grantDiscount = async () => {
    try {
      const { data } = await api.account.grant50PercentOff();
      onBillingInfoUpdated(extendBillingInfo(data));
      accept();
    } catch (e) {
      showErrorToast(getErrorForToast(e));
      throw e;
    }
  };

  return {
    grantDiscount,
  };
};
